export const LOCAL_STORAGE_COLOR_MODE_KEY = 'color_mode';
